import { Component } from '@angular/core';

@Component({
  selector: 'app-media-browse',
  templateUrl: './media-browse.component.html',
  styleUrls: ['./media-browse.component.css']
})
export class MediaBrowseComponent {
  navLinks = [
    { path: 'images', label: 'Images', icon: 'photo_library' },
    { path: 'videos', label: 'Videos', icon: 'videocam' }
  ];
}
